import React from 'react';

export const MoreActivitiesBody = ({ useTypes, callback }) => {
  const alphaActivites = _.sortBy(useTypes, 'dropdown');

  return (
    <div className='popular-activities'>
      <h3 className='title text-center'>Popular Activities</h3>
      <div>
        <ul>
          {_.map(alphaActivites, (act, i) => {
            return (
              <div key={`activity_${i}`}>
                <li>
                  <a
                    onClick={() => callback(act.dropdown)}
                    data-name={act.dropdown}
                    data-id={act.id}
                    href='#'
                  >
                    {act.dropdown}
                  </a>
                </li>
              </div>
            );
          })}
        </ul>
      </div>
    </div>
  );
};
